<template>
  <div class="w-full h-full">
    <input
      v-model="values"
      class="h-full border-0 w-full px-2 bg-transparent rounded-lg font-family"
      type="text"
      @input="$emit('input', values)"
    />
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      values: this.value
    };
  }
};
</script>

<style lang="scss" scoped>
.font-family {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 16px;
}
</style>
